import immutableStore from 'alt-utils/lib/ImmutableUtil';
import immutable from 'immutable';
import alt from 'components/Dispatcher';
import CrmSyncActions from 'actions/crm/CrmSyncActions';
import CallSyncCrmSource from 'sources/crm/CallSyncCrmSource';
import BrowserStore from 'stores/BrowserStore';

/**
 * CallSyncCRMStore is a ReactJS store that links <CallSyncCRMDialog/> with a backend source
 */
@immutableStore
class CallSyncCRMStore {
  constructor() {
    this.state = immutable.Map({
      // fileUploadId stores the value of the m.FileUpload.id value whose crm-data has been synced
      fileUploadId: null,
      // result stores the value of the crm-data-sync status
      result: null,
    });
    this.bindActions(CrmSyncActions);
    this.registerAsync(CallSyncCrmSource);
  }

  /**
   * Sync the CRM data to the backend
   * @param {Array.<String>} args Array of data to be synced to the backend such as FileUpload.id, contact or company
   */
  onSyncCrmData(args) {
    const [fileUploadId, contact, company, objectId] = args;
    setImmediate(() => {
      this.getInstance().syncData(fileUploadId, contact, company, objectId);
    });
  }

  onClearSyncCRMFileUploadId() {
    const state = this.state.set('fileUploadId', null);
    this.setState(state);
  }

  /**
   * Store the CRM data sync response in `this.state` so that we can re-check the crm-sync status if we want
   * @param {Object} resp Server-side response object that contains the crm-sync result
   */
  onSyncCrmDataSuccess(resp) {
    const data = resp.data;
    let state = this.state.set('fileUploadId', data.id);
    state = state.set('result', data.result);
    this.setState(state);
    const timezone = BrowserStore.getState().timezone;
    setImmediate(() => {
      CrmSyncActions.updateCallSyncData(
        data.id,
        data.contact,
        data.company,
        data.crm_link,
        timezone
      );
    });
  }
}

export default alt.createStore(CallSyncCRMStore, 'CallSyncCRMStore');
